//#region IMPORTS
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Promo } from "../../models/promo";
import dateHelperWeirdFromBackend from "../../helpers/dateHelperWeirdFromBackend";
import useBasketGate from "../../hooks/useBasketGate";
//#endregion

//#region INTERFACE
interface Props {
  promo: Promo;
}
//#endregion

export default function BasketEmptyPromoItem({ promo }: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Router
  const history = useHistory();

  // Cross-basket gate
  const { guardPromoAction } = useBasketGate();
  //#endregion

  //#region RENDER
  return (
    <li
      className="relative flex items-center space-x-6 py-4 hover:cursor-pointer"
      onClick={guardPromoAction(promo.id, () =>
        history.push(`/backorder/promo/${promo.id}`)
      )}
    >
      <img
        className="h-16 w-16 flex-none rounded-full bg-gray-50"
        src={
          promo.picture_url ??
          process.env.PUBLIC_URL +
            "/images/placeholder/placeholder_project__image.jpg"
        }
        alt={promo.code}
      />

      <div className="min-w-0 flex-1">
        <div className="text-base font-medium text-gray-900">
          <span aria-hidden="true" className="absolute inset-0" />
          {promo.code}
        </div>
        <p className="text-base text-gray-500">
          {t("rituals.thisProjectIsAvailableFrom$VAR$until$VAR2$")
            .replace(
              "$VAR$",
              dateHelperWeirdFromBackend(promo.active_from_date)
            )
            .replace(
              "$VAR2$",
              dateHelperWeirdFromBackend(promo.active_to_date)
            )}
        </p>
      </div>
      <div className="self-center">
        <ChevronRightIcon className="w-5 h-5 text-gray-900" />
      </div>
    </li>
  );
  //#endregion
}
